import React from 'react';
import PropTypes from 'prop-types';

import Header from '../components/Header';
import ExpoDesktop from '../components/ExpoDesktop';
import ExpoMobile from '../components/ExpoMobile';
import {withStore, withScreenCheck} from '../hoc';
import {PageAction} from '../actions';

/**
 * SectionPage
 */
class SectionPage extends React.Component {
  static displayName = 'SectionPage';
  static propTypes = {
    store: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
    className: PropTypes.string,
    tag: PropTypes.string,
  };

  static defaultProps = {
    tag: null,
    className: 'SectionPage',
  };

  /**
   * @override
   */
  componentDidMount() {
    if (!this.props.store.MenuOpen.first()) {
      PageAction.toggleMenu.defer();
    }
  }

  /**
   * @override
   */
  render() {
    return (
      <div className={`${this.className} ${this.props.className || ''}`}>
        <Header
          tag={this.props.tag}
          toggleTag={console.log}
          unselectTag={this.unselectTag}
          section={this.props.section}
          {...this.props}
        />
        {this.props.screen === 'mobile' ? (
          <ExpoMobile tag={this.props.tag} {...this.props} />
        ) : (
          <ExpoDesktop tag={this.props.tag} {...this.props} />
        )}
      </div>
    );
  }
}
export default withScreenCheck(withStore(SectionPage));
